module.exports = __webpack_public_path__ + "img/logo_vn_guide.a14a54cd.png";